export class DeviceAlertConfig {
    slackEnabled: boolean
    opsgenieEnabled: boolean
    id: number
    deviceRefId: string
}